import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from 'app/public/services/analytics.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { CommonService } from 'app/shared/services/common.service';
import { Subscriber } from 'rxjs';

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss']
})
export class PaymentCompleteComponent implements OnInit {
  isSuccess: boolean;
  subscriptions = new Subscriber();
  constructor(private route: ActivatedRoute, 
    private commonService: CommonService, 
    private localizationService: LocalizationService,
    private analytics:AnalyticsService
  ) {
    this.subscriptions.add(this.route.data.subscribe(data => {
      this.isSuccess = data?.success;
    }));
  }
  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('PAYMENT.HEADER'))
     this.analytics.sendEvent('payment-complete');  
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
